import { routesForLanguage } from './routes';
import { useContext } from 'react';
import DataContext from '../components/DataContext/DataContext';

const useRoutes = () => {
  const { org, lang } = useContext(DataContext) || {};
  const routes = routesForLanguage(org, lang);

  return routes;
};

export default useRoutes;
